import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import accountService from "../service-api/accountService";
import sourceService from "../service-api/sourceService";

// Initial state
const initialState = {
  data: [],
  activeSources: [],
  error: null,
  isLoading: true,
};

export const fetchAllSources = createAsyncThunk(
  "data/fetchAllSources",
  async () => {
    const response = await sourceService.fetchAllSources();
    return response.data;
  }
);

export const fetchAllActiveSources = createAsyncThunk(
  "data/fetchAllActiveSources",
  async () => {
    const response = await sourceService.fetchAllActiveSources();
    return response.data;
  }
);

export const updateSource = createAsyncThunk(
  "data/updateSource",
  async ({ id, obj }, { dispatch }) => {
    const response = await sourceService.updateSource(id, obj);
    dispatch(fetchAllSources());
    return response.data;
  }
);

export const addSource = createAsyncThunk(
  "data/addSource",
  async ({ obj }, { dispatch }) => {
    const response = await sourceService.addSource(obj);
    dispatch(fetchAllSources());
    return response.data;
  }
);

// Create slice
const sourceSlice = createSlice({
  name: "source",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSources.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllSources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchAllSources.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAllActiveSources.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllActiveSources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activeSources = action.payload.value;
      })
      .addCase(fetchAllActiveSources.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateSource.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSource.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateSource.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addSource.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addSource.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addSource.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default sourceSlice.reducer;
